export const version = "ethers/5.0.32";
//# sourceMappingURL=_version.js.map